/**
 * Windows サポート終了OSのお知らせページ
 **/
import { WindowsSupportEndText } from "../components/WindowsSupportEndText";

/**
 *
 * @returns Windows サポート終了OSのお知らせページのJSX Element
 */
export const WindowsSupportEnd: React.FC = () => {
  return <WindowsSupportEndText softName="CMCD-200ソフトウェア" />;
};
